/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TranslateInputs */

const cs_enum_translate = /** @type {(inputs: Enum_TranslateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Překlad`)
};

const en_enum_translate = /** @type {(inputs: Enum_TranslateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate`)
};

/**
* | output |
* | --- |
* | "Translate" |
*
* @param {Enum_TranslateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_translate = /** @type {((inputs?: Enum_TranslateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TranslateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_translate(inputs)
	return cs_enum_translate(inputs)
});